import "./styles.scss";
import React from "react";

export function Throbber() {
  return <div className="throbber" />;
}
